import Events from '@activebrands/core-web/libs/Events';
import { FormEvents, FormFlow } from '@activebrands/core-web/libs/Events/types';

/**
 * Fire a form_submit tracking event for a confirmed successful submission. Passing client
 * validation is not enough — this must be called from the success path once the API accepts
 * the submission, so `form_submit` counts completions rather than attempts.
 */
const trackFormSubmit = (flow: FormFlow) => {
    try {
        Events.trigger(FormEvents.SUBMIT, { flow });
    } catch {
        // Analytics must never break the calling flow.
    }
};

export default trackFormSubmit;
